<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <!-- Close layer for mobile sidebar -->
    <div
      class="close-layer"
      :class="{ visible: $sidebar.showSidebar }"
      @click="toggleSidebar"
    ></div>

    <side-bar>
      <template slot="links">
        <sidebar-item
          :link="{
            name: dashboardLabel,
            path: '/pages/dashboard',
            icon: 'fa fa-tachometer-alt',
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: messagesLabel,
            path: '/pages/messages',
            icon: 'fa fa-comments',
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Calendar',
            path: '/pages/calendar',
            icon: 'fa fa-calendar-alt',
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Shifts',
            path: '/pages/shifts',
            icon: 'fa fa-calendar-check',
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: timeOffLabel,
            path: '/pages/time-off',
            icon: 'fa fa-umbrella-beach',
          }"
        ></sidebar-item>
        <!--        <sidebar-item-->
        <!--          :link="{-->
        <!--            name: scheduleChangeLabel,-->
        <!--            path: '/pages/schedule-change-requests',-->
        <!--            icon: 'fa fa-calendar-week',-->
        <!--          }"-->
        <!--        ></sidebar-item>-->
        <sidebar-item
          v-if="!isCaregiver"
          :link="{
            name: 'Authorizations',
            path: '/pages/authorizations',
            icon: 'fa fa-file-signature',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="isAdmin"
          :link="{
            name: 'Reports',
            path: '/pages/reports',
            icon: 'fa fa-chart-bar',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="isAdmin"
          :link="{
            name: 'Payments',
            path: '/pages/payment-tracking',
            icon: 'fa fa-credit-card',
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Caregivers',
            path: '/pages/caregivers',
            icon: 'fa fa-user-nurse',
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Clients',
            path: '/pages/clients',
            icon: 'fa fa-users',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="!isCaregiver"
          :link="{
            name: 'Counselors',
            path: '/pages/counselors',
            icon: 'fa fa-user-tie',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="!isCaregiver"
          :link="{
            name: 'Offices',
            path: '/pages/offices',
            icon: 'fa fa-building',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="!isCaregiver"
          :link="{
            name: 'Payroll',
            path: '/pages/payroll',
            icon: 'fa fa-money-bill-wave',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="isAdmin"
          :link="{ name: 'Admin', path: '/pages/admin', icon: 'fa fa-cog' }"
        ></sidebar-item>
        <sidebar-item
          v-if="isAdmin"
          :link="{ name: 'Settings', icon: 'fa fa-sliders' }"
        >
          <sidebar-item
            :link="{ name: 'Service Codes', path: '/pages/settings/service-codes' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Non-Service Codes', path: '/pages/settings/non-service-codes' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'DSPD Questions', path: '/pages/settings/dspd-shift-questions' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'VR Questions', path: '/pages/settings/vr-shift-questions' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'VR Activities', path: '/pages/settings/vr-activity-lists' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'DSPD Email Alerts', path: '/pages/settings/dspd-email-alerts' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'AI Email Prompts', path: '/pages/settings/ai-email-prompts' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Mileage', path: '/pages/settings/mileage-settings' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="!isCaregiver"
          :link="{
            name: 'CBS Programs',
            path: '/pages/cbs-programs',
            icon: 'fa fa-sitemap',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="!isCaregiver"
          :link="{
            name: 'Compliance',
            path: '/pages/compliance-dashboard',
            icon: 'fa fa-clipboard-check',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="!isCaregiver"
          :link="{
            name: 'Verification',
            path: '/pages/verification',
            icon: 'fa fa-shield-alt',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="isAdmin"
          :link="{ name: 'Audit Logs', path: '/pages/audit-logs', icon: 'fa fa-clipboard-list' }"
        ></sidebar-item>
        <sidebar-item
          v-if="isAdmin"
          :link="{ name: 'Help', path: '/pages/help', icon: 'fa fa-circle-question' }"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel" ref="mainPanel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { useNotificationsStore } from "@/stores/notificationsStore";
import { useLoginStore } from "@/stores/loginStore";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    TopNavbar,
    DashboardContent,
  },
  data() {
    return {
      ps: null, // Store PerfectScrollbar instance
    };
  },
  computed: {
    dashboardLabel() {
      const notificationsStore = useNotificationsStore();
      const count = notificationsStore.totalNotificationCount;
      return count > 0 ? `Dashboard (${count})` : "Dashboard";
    },
    messagesLabel() {
      const notificationsStore = useNotificationsStore();
      const count = notificationsStore.unreadMessages;
      return count > 0 ? `Messages (${count})` : "Messages";
    },
    timeOffLabel() {
      const notificationsStore = useNotificationsStore();
      const loginStore = useLoginStore();
      const count = notificationsStore.pendingTimeOffRequests;

      // Only show count for admins
      if (loginStore.isAdmin && count > 0) {
        return `Time Off (${count})`;
      }
      return "Time Off";
    },
    scheduleChangeLabel() {
      const notificationsStore = useNotificationsStore();
      const loginStore = useLoginStore();
      const count = notificationsStore.pendingScheduleChangeRequests;

      // Only show count for admins
      if (loginStore.isAdmin && count > 0) {
        return `Schedule Changes (${count})`;
      }
      return "Schedule Changes";
    },
    isCaregiver() {
      const loginStore = useLoginStore();
      return loginStore.isCaregiver;
    },
    isAdmin() {
      const loginStore = useLoginStore();
      return loginStore.isAdmin;
    },
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    handleEscapeKey(event) {
      if (event.key === "Escape" && this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // Store the PerfectScrollbar instance
        const mainPanelElement = document.querySelector('.main-panel');
        if (mainPanelElement) {
          this.ps = new PerfectScrollbar(mainPanelElement);
        }
        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
    scrollToTop() {
      this.$refs.mainPanel.scrollTop = 0;
    },
    scrollLastIntoView() {
      const mainPanel = this.$refs.mainPanel;

      // Scroll up by a fixed amount to escape white space after deletion
      setTimeout(() => {
        const currentScroll = mainPanel.scrollTop;
        const newScroll = Math.max(0, currentScroll - 400); // Scroll up by 400px

        mainPanel.scrollTop = newScroll;

        // Update PerfectScrollbar to reflect the scroll change
        if (this.ps) {
          this.ps.update();
        }
      }, 100);
    },
  },
  watch: {
    $route() {
      this.scrollToTop();
    },
    "$sidebar.showSidebar"(open) {
      // Scroll lock while the mobile drawer is open (CSS only applies <1200px)
      document.body.classList.toggle("sidebar-drawer-open", open);
    },
  },
  async mounted() {
    this.initScrollbar();
    this.$root.$on("scroll-to-top", this.scrollToTop);
    this.$root.$on("scroll-last-into-view", this.scrollLastIntoView);
    document.addEventListener("keydown", this.handleEscapeKey);

    // Load notifications on mount
    const notificationsStore = useNotificationsStore();
    await notificationsStore.loadNotifications();

    // Set up auto-refresh every 60 seconds
    this.notificationInterval = setInterval(() => {
      notificationsStore.loadNotifications();
    }, 60000);
  },
  beforeDestroy() {
    this.$root.$off("scroll-to-top", this.scrollToTop);
    this.$root.$off("scroll-last-into-view", this.scrollLastIntoView);
    document.removeEventListener("keydown", this.handleEscapeKey);
    document.body.classList.remove("sidebar-drawer-open");
    if (this.notificationInterval) {
      clearInterval(this.notificationInterval);
    }
  },
};
</script>
<style>
/* Override responsive sidebar behavior for left-side mobile.
   Breakpoint matches the template's off-canvas rules (_responsive.scss,
   max-width: 1200px) and the navbar-toggler visibility (d-xl-none). */
@media (max-width: 1199.98px) {
  /* Safety net: one over-wide element must not force the whole page
     wider than the screen (users end up pinch-zooming to fit). Wide
     content belongs in its own scrollable container (.table-container
     etc.); anything else gets clipped at the viewport edge instead.
     `clip` (unlike `hidden`) can't become a scroll container. */
  html,
  body {
    overflow-x: hidden;
    overflow-x: clip;
  }

  /* Keep the top navbar (hamburger, user, log out) pinned while the page
     scrolls. Fixed, not sticky: sticky re-tracks the scroll offset every
     frame and visibly jitters when the browser drops off its compositor
     fast path; fixed is viewport-anchored with no per-frame work. Requires
     that no ancestor carries a transform (see the .nav-open rule below)
     and the padding-top compensation on .main-panel. */
  .main-panel .navbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    /* Under the drawer backdrop (999) and sidebar (1000), above content */
    z-index: 998;
  }

  /* Reserve the fixed navbar's 61px (min-height 50 / max-height 61 in
     _navbars.scss; renders at the 61px cap on all sub-1200 widths).
     transform none: _responsive.scss puts a permanent translate3d(0) +
     transition on .main-panel for the push animation the overlay drawer
     no longer uses — an identity transform still makes .main-panel the
     containing block for fixed descendants, which would re-anchor the
     fixed navbar (and any non-appended el-dialog) to the panel instead
     of the viewport. */
  .main-panel {
    padding-top: 61px;
    transform: none !important;
    transition: none !important;
  }

  .sidebar {
    left: 0 !important;
    right: auto !important;
    transform: translate3d(-260px, 0, 0) !important;
    /* Match the backdrop's 0.3s fade so drawer and dim move together */
    transition: transform 0.3s ease !important;
    /* Above the close-layer backdrop so the open menu stays tappable */
    z-index: 1000 !important;
    /* Scrolling the menu shouldn't chain-scroll the page behind it */
    overscroll-behavior: contain;
  }

  .nav-open .sidebar {
    transform: translate3d(0px, 0, 0) !important;
    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.35);
  }

  /* Overlay drawer: the sidebar slides over the content, which stays put.
     Neutralizes the template's push behavior (_responsive.scss shifts
     .main-panel 260px right and re-positions it while nav-open).
     `none`, not translate3d(0,0,0): any transform here would turn
     .main-panel into the containing block for the fixed navbar above,
     un-pinning it from the viewport whenever the drawer opens. */
  .nav-open .main-panel {
    transform: none !important;
    position: relative !important;
  }

  /* Lock background scrolling while the drawer is open
     (class toggled on <body> by DashboardLayout) */
  body.sidebar-drawer-open {
    overflow: hidden;
  }

  .close-layer {
    position: fixed !important;
    top: 0;
    left: 0 !important;
    width: 100% !important;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    /* Below the sidebar (1000); above the main panel and navbars */
    z-index: 999 !important;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    /* Never intercept clicks while hidden */
    pointer-events: none !important;
  }

  .close-layer.visible {
    opacity: 1;
    visibility: visible;
    pointer-events: auto !important;
  }
}
</style>
